export default __webpack_public_path__ + "4e84e7826119f83e9b46553e8d305038.svg";